import React from "react";
import createIcon from "./utils";

export default createIcon(
	<svg viewBox="0 -960 960 960" fill="currentColor">
		<path d="M120-280v-400h720v400H120Zm80-80h560v-240H200v240Zm0 0v-240 240Z" />
	</svg>,
	"Variables"
);
